import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconLabelWrapperFn = /* @__PURE__ */ createRecipe('radio-icon-label-wrapper', {}, [])

const radioOnlyIconLabelWrapperVariantMap = {}

const radioOnlyIconLabelWrapperVariantKeys = Object.keys(radioOnlyIconLabelWrapperVariantMap)

export const radioOnlyIconLabelWrapper = /* @__PURE__ */ Object.assign(memo(radioOnlyIconLabelWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconLabelWrapper',
  __getCompoundVariantCss__: radioOnlyIconLabelWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconLabelWrapperVariantKeys,
  variantMap: radioOnlyIconLabelWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconLabelWrapperVariantKeys)
  },
  getVariantProps: radioOnlyIconLabelWrapperFn.getVariantProps,
})